import { getEndpoint, LWA_PLATFORM, ID_SITE, LOCAL_LAUNCH } from "../providers/endpoint.provider";
import { appIdByAppName, runningApp } from "./app";

const getLwaRoutes = (params) => ({
    CONFIRM_CONNECTION: `/product/confirm-connection${params || ''}`,
    LAUNCH_PRODUCT: `/product/launch${params || ''}`,
    AUTH: `/authenticate${params || ''}`
});

const buildAuthParams = (authParams) => {
    const paramsArray = [
        `${authParams?.email ? `e=${encodeURIComponent(authParams?.email)}` : ''}`,
        `${authParams?.mode ? `&sc=${authParams?.mode}` : ''}`,
        `${authParams?.redirectUrl ? `&r=${encodeURIComponent(authParams?.redirectUrl)}`: ''}`,
    ];

    return paramsArray.join('');
};

const getLwaRouteParams = ({ lwid, authParams } = {}) =>  ({
    APP: `?a=${appIdByAppName[runningApp]}`,
    LWID: `?i=${lwid}`,
    AUTH: `?${buildAuthParams(authParams)}`,
});

export const urlKeycloakToken = `${getEndpoint(ID_SITE)}/auth/realms/terradatum/protocol/openid-connect/token`
export const urlPlatformLaunch =
    `${getEndpoint(LWA_PLATFORM)}${getLwaRoutes(getLwaRouteParams().APP).LAUNCH_PRODUCT}${getEndpoint(LOCAL_LAUNCH)}`;
export const urlPlatformConnection = (lwid) =>
    `${getEndpoint(LWA_PLATFORM)}${getLwaRoutes(getLwaRouteParams({lwid}).LWID).CONFIRM_CONNECTION}`;
export const urlPlatformAuth = (authParams) =>
    `${getEndpoint(LWA_PLATFORM)}${getLwaRoutes(getLwaRouteParams({authParams}).AUTH).AUTH}`;
export const urlPlatformHome = getEndpoint(LWA_PLATFORM);

export const MAX_ENDPOINT_RETRIES = 5;
export const CANCELED_ENDPOINT_CODE = 20;

export const responseKeys = {
    recruitingSoldTotals: 'recruitingSoldTotals',
    results: 'results',
    totals: 'totals',
};

export const HTTP_RESPONSES = Object.freeze({
    badRequest: 400,
    unauthorized: 401,
    forbidden: 403,
    notFound: 404,
    conflict: 409,
    payloadTooLarge: 413,
});

export const API_ERROR_MESSAGES = Object.freeze({
    400: "Unable to update the item. Please review any dependencies and try again.",
    500: "Oops! Something went wrong with our server. Please try again in a bit.",
});

export const apiRequestTypes = Object.freeze({
    post: 'POST',
    get: 'GET',
    delete: 'DELETE',
    put: 'PUT',
});
